import { FlowNodeRegistry } from '../typings';
import { StartNodeRegistry } from './start';
import { SQLNodeRegistry } from './sql/sql';
import { LoopNodeRegistry } from './loop';
import { LLMNodeRegistry } from './llm';
import { JSNodeRegistry } from './js/js';
import { FeishuSheetNodeRegistry } from './feishuSheet/feishu-sheet';
import FeishuNotificationNodeRegistry from './feishuNotification/feishu-notification';
import { EndNodeRegistry } from './end';
import { WorkflowNodeType } from './constants';
import { ConditionNodeRegistry } from './condition';
import { CommentNodeRegistry } from './comment';
import { ApiCallNodeRegistry } from './apiCall/api-call';
export { WorkflowNodeType } from './constants';

export const nodeRegistries: FlowNodeRegistry[] = [
  // ConditionNodeRegistry,
  StartNodeRegistry,
  EndNodeRegistry,
  // LLMNodeRegistry,
  // LoopNodeRegistry,
  // CommentNodeRegistry,
  SQLNodeRegistry,
  JSNodeRegistry,
  FeishuSheetNodeRegistry,
  FeishuNotificationNodeRegistry,
  ApiCallNodeRegistry,
];

export const visibleNodeRegistries = nodeRegistries.filter(
  (r) => r.type !== WorkflowNodeType.Comment
);
